(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fenlo-color-explore"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('fenlo-color-explore')){
    customElements.define('fenlo-color-explore',class extends HTMLElement{
      connectedCallback(){
        if(this.ready)return;this.ready=true;
        const toggle=this.querySelector('button'),panel=this.querySelector('.fc-qnav__panel');
        const wide=matchMedia('(min-width:1440px)'),reduce=matchMedia('(prefers-reduced-motion:reduce)');
        const chapters=this.querySelector('[data-product-chapters]');
        if(chapters){document.querySelectorAll('.anav a[href^="#"]').forEach(a=>chapters.appendChild(a.cloneNode(true)));}
        const links=Array.from(this.querySelectorAll('nav a')).filter(a=>{
          if(a.hasAttribute('data-page-top'))return true;
          if(document.getElementById(a.hash.slice(1)))return true;
          a.remove();return false;
        });
        const close=(focus=false)=>{this.classList.remove('is-open');toggle.setAttribute('aria-expanded','false');panel.inert=!wide.matches;if(focus)toggle.focus({preventScroll:true});};
        toggle.addEventListener('click',()=>{const open=!this.classList.contains('is-open');this.classList.toggle('is-open',open);toggle.setAttribute('aria-expanded',String(open));panel.inert=!open&&!wide.matches;if(open){links[0]?.focus({preventScroll:true});panel.scrollTop=0;}});
        document.addEventListener('keydown',e=>{if(e.key==='Escape'&&this.classList.contains('is-open')){e.preventDefault();close(true);}});
        document.addEventListener('click',e=>{if(!this.contains(e.target))close();});
        this.addEventListener('focusout',()=>{setTimeout(()=>{if(!this.contains(document.activeElement))close();},0);});
        const headerOffset=()=>{
          let bottom=0;
          document.querySelectorAll('.sf-header .header__wrapper,.header__wrapper,.anav.on').forEach(el=>{const r=el.getBoundingClientRect();if(r.top<innerHeight/2&&r.bottom>0)bottom=Math.max(bottom,r.bottom);});
          return Math.min(bottom,innerHeight/2)+16;
        };
        const navigate=(e,a)=>{
          if(e.button!==0||e.metaKey||e.ctrlKey||e.altKey||e.shiftKey)return;
          e.preventDefault();e.stopPropagation();
          const top=a.hasAttribute('data-page-top');
          let target=top?null:document.getElementById(a.hash.slice(1));
          if(!top&&!target)return;
          if(a.dataset.gallery){window.dispatchEvent(new CustomEvent('fenlo:play-gallery',{detail:{pk:a.dataset.gallery}}));target=target.querySelector('video')||target;}
          if(a.hasAttribute('data-film')){const video=target.querySelector('video');if(video){const player=video.closest('fenlo-color-video');if(player&&player.playVideo)player.playVideo();else{const play=video.play();if(play)play.catch(()=>{});}target=video;}}
          close();
          if(top){const heading=document.querySelector('h1')||document.body;if(!heading.hasAttribute('tabindex'))heading.setAttribute('tabindex','-1');heading.focus({preventScroll:true});scrollTo({top:0,behavior:reduce.matches?'instant':'smooth'});return;}
          if(!target.hasAttribute('tabindex'))target.setAttribute('tabindex','-1');
          target.focus({preventScroll:true});
          const y=scrollY+target.getBoundingClientRect().top-headerOffset();
          scrollTo({top:Math.max(0,y),behavior:reduce.matches?'instant':'smooth'});
          if(location.hash!==a.hash)history.pushState(null,'',a.hash);
        };
        this.addEventListener('click',e=>{const a=e.target.closest('a');if(a&&this.contains(a))navigate(e,a);});
        document.querySelectorAll('[data-fc-home-watch]').forEach(a=>a.addEventListener('click',e=>navigate(e,a)));
        let frame=0;
        const update=()=>{
          frame=0;
          let bottom=88;
          document.querySelectorAll('.satc,.fc-interest-float,#preview-bar-iframe,.footer-mobile__common').forEach(el=>{const r=el.getBoundingClientRect();if(!el.hidden&&r.height&&r.top<innerHeight&&r.bottom>innerHeight/2)bottom=Math.max(bottom,innerHeight-r.top+12);});
          this.style.setProperty('--fc-qnav-bottom',Math.ceil(bottom)+'px');
          this.style.setProperty('--fc-qnav-header',Math.ceil(headerOffset())+'px');
          this.style.setProperty('--fc-qnav-panel-height',Math.max(80,Math.min(460,innerHeight-headerOffset()-bottom-70))+'px');
          const viewport=window.visualViewport;
          const active=document.activeElement;
          const editing=active&&(active.isContentEditable||/^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName));
          const keyboard=editing&&viewport&&innerHeight-viewport.height-viewport.offsetTop>120;
          const overlay=document.documentElement.classList.contains('prevent-scroll')||document.body.classList.contains('prevent-scroll');
          this.hidden=Boolean(keyboard||overlay);
          if(this.hidden)close();
          let current=null,best=-Infinity;
          const line=headerOffset()+64;
          links.forEach(a=>{if(a.hasAttribute('data-page-top'))return;const el=document.getElementById(a.hash.slice(1));if(!el)return;const y=el.getBoundingClientRect().top;if(y<=line&&y>best){best=y;current=a;}});
          links.forEach(a=>{if(a===current)a.setAttribute('aria-current','location');else a.removeAttribute('aria-current');});
          panel.inert=!wide.matches&&!this.classList.contains('is-open');
        };
        const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
        this.addEventListener('click',schedule);
        window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});window.addEventListener('pageshow',schedule);
        document.addEventListener('focusin',schedule);document.addEventListener('focusout',schedule);
        if(window.visualViewport){visualViewport.addEventListener('resize',schedule);visualViewport.addEventListener('scroll',schedule);}
        wide.addEventListener('change',()=>{close();schedule();});
        new MutationObserver(schedule).observe(document.documentElement,{attributes:true,attributeFilter:['class']});
        new MutationObserver(schedule).observe(document.body,{attributes:true,attributeFilter:['class']});
        update();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fenlo-color-video"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('fenlo-color-video')){
    customElements.define('fenlo-color-video',class extends HTMLElement{
      connectedCallback(){
        if(this.dataset.ready)return;
        const video=this.querySelector('video'),button=this.querySelector('button'),status=this.querySelector('.fc-film__status'),label=this.querySelector('.fc-film__play-label');
        if(!video||!button||!status||!label)return;
        this.dataset.ready='true';
        video.muted=true;
        video.playsInline=true;
        button.hidden=false;
        let loadingTimer=0,playAttempt=0;
        const clearLoading=()=>{if(loadingTimer){clearTimeout(loadingTimer);loadingTimer=0;}};
        const showStatus=kind=>{status.textContent=kind?status.dataset[kind]||'':'';status.hidden=!kind;};
        const loading=()=>{
          if(status.textContent===status.dataset.slow)return;
          showStatus('loading');
          clearLoading();
          loadingTimer=setTimeout(()=>{
            loadingTimer=0;
            if(video.paused||video.ended)return;
            showStatus('slow');label.textContent=label.dataset.retry;button.hidden=false;
          },15000);
        };
        if('IntersectionObserver' in window){
          const warm=new IntersectionObserver(entries=>{
            if(entries.some(entry=>entry.isIntersecting)){
              video.preload='metadata';
              if(video.networkState===0)video.load();
              warm.disconnect();
            }
          },{rootMargin:'200px'});
          warm.observe(this);
        }
        const fail=error=>{
          clearLoading();
          const galleryFrame=this.closest('[data-gallery-video]');
          if((error&&error.name==='AbortError')||(galleryFrame&&galleryFrame.hidden)){
            showStatus('');
            return;
          }
          showStatus('error');label.textContent=label.dataset.retry;button.hidden=false;
        };
        this.playVideo=()=>{
          button.hidden=true;
          const retry=label.textContent===label.dataset.retry;
          showStatus('');
          loading();
          video.focus({preventScroll:true});
          if(retry||video.error||video.networkState===0)video.load();
          const current=++playAttempt;
          const playing=video.play();
          if(playing)playing.catch(error=>{if(current===playAttempt)fail(error);});
        };
        button.addEventListener('click',this.playVideo);
        video.addEventListener('play',()=>{
          button.hidden=true;
          loading();
          document.querySelectorAll('fenlo-color-video video').forEach(other=>{if(other!==video)other.pause();});
        });
        video.addEventListener('waiting',()=>{if(!video.paused)loading();});
        video.addEventListener('playing',()=>{clearLoading();showStatus('');label.textContent=label.dataset.play;button.hidden=true;});
        video.addEventListener('error',fail);
        video.addEventListener('pause',()=>{++playAttempt;clearLoading();if(status.textContent!==status.dataset.error)showStatus('');if(!video.ended)button.hidden=false;});
        video.addEventListener('ended',()=>{clearLoading();showStatus('');button.hidden=false;});
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
